import { createAsyncThunk } from '@reduxjs/toolkit';

import VerificationProcessApi from 'api/curo/VerificationProcessApi';
import { VerificationProcessActionType } from 'enums/curo/VerificationProcessActionType';
import rejectWithValueHelper from 'utils/rejectWithValueHelper';

export const createVerifyEmailVerificationCode = (api: VerificationProcessApi) =>
  createAsyncThunk(
    VerificationProcessActionType.VerifyEmailVerificationCode,
    async ({ applicationId, code }: { applicationId: string; code: string }, thunkApi) => {
      try {
        const { status } = await api.verifyEmailVerificationCode(applicationId, code);

        return { status };
      } catch (error) {
        return rejectWithValueHelper(error as Error, thunkApi);
      }
    },
  );
